export default __webpack_public_path__ + "static/media/rating_0.98b1988f.svg";